<nav class="navbar navbar-expand bg-light fixed-top no-print" style="border-bottom: 1px solid lightgrey" >

  <div class="container-fluid">

    <a [routerLink]="'/splash'" class="navbar-brand banner-collapse-lg" aria-current="page">
      <img height="38" src="assets/img/sellafield1.png" />
    </a>

    <div class="collapse navbar-collapse" [ngbCollapse]="isMenuCollapsed">

      <ul class="navbar-nav me-auto mb-2 mb-lg-0">

        <sk-banner-title></sk-banner-title>

      </ul>

      <ul class="navbar-nav float-end"  *ngIf="showBannerContent">

        <sk-banner-status></sk-banner-status>

        <sk-banner-monitor></sk-banner-monitor>

        <sk-banner-help></sk-banner-help>

        <sk-banner-refresh></sk-banner-refresh>

        <sk-banner-notification></sk-banner-notification>

        <!--<sk-banner-scenario></sk-banner-scenario>-->

        <sk-banner-user></sk-banner-user>

        <!-- <sk-banner-mega-menu></sk-banner-mega-menu> -->

      </ul>

    </div>

  </div>

</nav>

<saker-logger aria-live="polite" aria-atomic="true"></saker-logger>

<div class="container" style="max-width: 100%">
  <router-outlet></router-outlet>
</div>